import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import SegmentedPicker from '../controls/segmentedPicker';
import { hasPermission } from '../../../utils/paths';
import entityComposition from '../classes/entityComposition';
import MFAModal from './mfaModal';
import DisableModal from './disableModal';
const SecretSetup = _ref => {
  let customer = _ref.customer,
    mfa = _ref.mfa,
    mfaActions = _ref.mfaActions,
    _ref$mfaEnabled = _ref.mfaEnabled,
    mfaEnabled = _ref$mfaEnabled === void 0 ? false : _ref$mfaEnabled,
    _ref$mfaRequired = _ref.mfaRequired,
    mfaRequired = _ref$mfaRequired === void 0 ? false : _ref$mfaRequired,
    _ref$onlyModal = _ref.onlyModal,
    onlyModal = _ref$onlyModal === void 0 ? false : _ref$onlyModal,
    _ref$onSuccess = _ref.onSuccess,
    onSuccess = _ref$onSuccess === void 0 ? null : _ref$onSuccess,
    userID = _ref.userID,
    _ref$username = _ref.username,
    username = _ref$username === void 0 ? null : _ref$username;
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    firstPin = _useState2[0],
    setFirstPin = _useState2[1];
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    secondPin = _useState4[0],
    setSecondPin = _useState4[1];
  const toggleDisableModal = () => mfaActions.toggleModal('disable');
  const toggleMFAModal = () => mfaActions.toggleModal('mfa');
  const onChange = (pinName, pin) => {
    if (mfa.error) {
      mfaActions.clearError();
    }
    if (pinName === 'firstPin') {
      setFirstPin(pin);
    } else if (pinName === 'secondPin') {
      setSecondPin(pin);
    }
  };
  const onSecretSave = async () => {
    // this method tries to log the user in
    await mfaActions.serverSaveSecret(userID, firstPin, secondPin);
    if (onSuccess) {
      onSuccess(secondPin);
    }
    setFirstPin('');
    setSecondPin('');
  };
  const disableMFA = () => {
    mfaActions.serverDeleteSecret(userID);
  };
  const handleMFAToggleChange = newValue => {
    if (newValue) {
      toggleMFAModal();
    } else {
      toggleDisableModal();
    }
  };

  // Define all potential render pieces
  const isDisabled = mfaRequired && !hasPermission('general', 'user_edit');
  const showDisableButton = !mfaRequired && mfaEnabled || hasPermission('general', 'user_edit') && mfaEnabled;
  const modalProps = {
    createNewSecret: mfaActions.loadSecret,
    onClose: toggleMFAModal,
    showModal: mfa.modals.mfa,
    mfaEnabled,
    username,
    pins: {
      firstPin,
      secondPin
    },
    customer,
    onSave: onSecretSave,
    onChange,
    secret: mfa.secret,
    error: mfa.error
  };
  const disableModalProps = {
    showModal: mfa.modals.disable,
    onAction: disableMFA,
    onHide: toggleDisableModal
  };
  const generateNewSecretAndToggle = () => {
    mfaActions.loadSecret();
    toggleMFAModal();
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: onlyModal ? 'none' : 'default'
    }
  }, /*#__PURE__*/React.createElement(DisableModal, disableModalProps), /*#__PURE__*/React.createElement(SegmentedPicker, {
    names: ['Enabled', 'Disabled'],
    values: [1, 0],
    label: "Multifactor Authentication",
    allowNull: false,
    value: mfaEnabled ? 1 : 0,
    onChange: handleMFAToggleChange,
    isDisabled: isDisabled
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    onClick: generateNewSecretAndToggle,
    className: "t-ss-generate-new tqc-control"
  }, "Generate New Secret For Authenticator"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("p", null, "Note: Successful creation of a new authentication secret will replace existing multi-factor authentication secret.")), /*#__PURE__*/React.createElement(MFAModal, modalProps), /*#__PURE__*/React.createElement("div", {
    style: {
      visibility: showDisableButton ? 'visible' : 'hidden'
    }
  }, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Button, {
    className: "t-ss-disable tqc-control",
    onClick: toggleDisableModal
  }, "Disable MFA")));
};
SecretSetup.propTypes = {
  mfaActions: PropTypes.shape({
    toggleModal: PropTypes.func,
    serverDeleteSecret: PropTypes.func,
    loadSecret: PropTypes.func,
    serverSaveSecret: PropTypes.func,
    clearError: PropTypes.func
  }).isRequired,
  mfa: PropTypes.shape({
    error: PropTypes.string,
    authPin: PropTypes.string,
    modals: PropTypes.shape({
      disable: PropTypes.bool,
      mfa: PropTypes.bool
    }),
    secret: PropTypes.string
  }).isRequired,
  mfaEnabled: PropTypes.bool,
  mfaRequired: PropTypes.bool,
  username: PropTypes.string,
  userID: PropTypes.string.isRequired,
  customer: PropTypes.string.isRequired,
  onlyModal: PropTypes.bool,
  onSuccess: PropTypes.func
};
export { SecretSetup as TestSecretSetup };
export default entityComposition(SecretSetup, ['mfa'], {}, []);